import { render } from "./lock-icon.vue?vue&type=template&id=45b1a269"
const script = {}
script.render = render

export default script